import { z } from "zod";
import { ZForenkletEllerDetaljertEnumSchema } from "../byggSchema";

export const ZOmProsjektetSchema = z.object({
  // 4
  isActive: z.boolean().default(true),
  tekst: z.string(),
  bygget: z.object({
    // 4.1
    isActive: z.boolean().default(true),
    tekst: z.string(),
  }),
  klima: z.object({
    // 4.2
    isActive: z.boolean().default(true),
    tekst: z.string(),
    klimatilpasning: z.object({
      // 4.2.1
      isActive: z.boolean().default(true),
      tekst: z.string(),
    }),
    uteklima: z.object({
      // 4.2.2
      isActive: z.boolean().default(true),
      tekst: z.string(),
    }),
    innvendigKlima: z.object({
      // 4.2.3
      isActive: z.boolean().default(true),
      tekst: z.string(),
      forenkletEllerDetaljert: ZForenkletEllerDetaljertEnumSchema,
    }),
  }),
});

export type IOmProsjektetSchema = z.infer<typeof ZOmProsjektetSchema>;
